require('angular').module('wowApp.common')
                  .service('CacheService', ['$rootScope', require('./cache-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/cacheservice/index.js
 **/